import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, Output, EventEmitter, inject, input, viewChild } from "@angular/core";

@Component({
  selector: "av-card-row-responsive",
  templateUrl: "./card-row-responsive.component.html",
  styleUrls: ["./card-row-responsive.component.scss"],
  standalone: false,
})
export class CardRowResponsiveComponent implements AfterViewInit {
  private renderer = inject(Renderer2);

  readonly primaryRef = viewChild<ElementRef<HTMLDivElement>>("rowPrimary");

  readonly icon = input<string>(undefined);
  readonly iconTooltip = input<string>(undefined);
  readonly flex = input(3);
  readonly bodyHidden = input(false);

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.primaryRef().nativeElement, "flex", this.flex());
  }
}
